import { render, staticRenderFns } from "./ContactLoadFailed.vue?vue&type=template&id=65e4303a&scoped=true&"
import script from "./ContactLoadFailed.vue?vue&type=script&lang=ts&"
export * from "./ContactLoadFailed.vue?vue&type=script&lang=ts&"
import style0 from "./ContactLoadFailed.vue?vue&type=style&index=0&id=65e4303a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e4303a",
  null
  
)

export default component.exports